var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',_vm._b({staticClass:"pa-5 mx-0",staticStyle:{"position":"relative"},attrs:{"tag":"section"}},'v-row',_vm.$attrs,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }